import axios from 'axios';
import * as comUtils from 'utils/Common';

export function loadIcon(url, frameDocument=document) {
  if (!comUtils.isBrowser()) return;
  axios.get(url)
    .then((response) => {
      let div = frameDocument.createElement("div");
      div.innerHTML = response.data;
      frameDocument.body.insertBefore(div, frameDocument.body.childNodes[0]);
  });
}

